import { IModule } from 'redux-state/layout/types.js';

/** Has Module Got a title */
export const moduleHasTitle = ({
  isDrawer,
  titleDefault,
  config: { title, subtitle, link },
}: Pick<IModule, 'isDrawer' | 'config'> & { titleDefault?: string }): boolean => {
  const newTitle = title ?? titleDefault ?? subtitle ?? link;
  if (newTitle) {
    return true;
  }
  if (isDrawer) {
    return true;
  }
  return false;
};
